import "./ServicesSection.css";
import { useServicesSection } from '../../Context/ServiceSectionContext';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const ServicesSection = ({ subServices, update }) => {
    const servicesSectionRef = useServicesSection();
    const navigate = useNavigate(); // Initialize navigate

    const handleServiceClick = (serviceId) => {
        update();
        setTimeout(() => navigate(`/portfolio?id=${serviceId}`), 2000)
    };

    return (
        <section ref={servicesSectionRef} id="services-section">
            {subServices.map((service, index) => (
                <div
                    key={service.id} // Ensure unique key for each service
                    className="bg-white position-relative service__banner border border-1 border-dark d-flex align-items-start gap-3 overflow-hidden"
                    onClick={() => handleServiceClick(service.id)} // Add click handler
                    style={{ cursor: 'pointer' }} // Indicate clickability
                >
                    <h2 className="text position-relative fs-1 fw-bold z-2 my-4 ms-4">
                        {service.title}
                    </h2>
                    <p className="text position-relative h5 z-2 my-4">[{index + 1}]</p>
                    <img
                        src={`https://api.glyphqai.com/uploads/mainservices/${service.image}`}
                        alt={service.title}
                        className="banner__img"
                    />
                    <div className="overlay z-1 w-100 position-absolute bottom-0"></div>
                </div>
            ))}
        </section>
    );
};

export default ServicesSection;
